module.exports = __webpack_public_path__ + "img/32x32x5.dcc85254.png";